import { useQuery } from '@tanstack/react-query'
import { Modal } from '../../components/ui/Modal'
import { Button } from '../../components/ui/Button'
import { MarkdownRenderer } from '../../components/ui/MarkdownRenderer'
import { documentationApi } from '../../api/documentation.api'
import { toast } from '../../store/toastStore'

export function LinkedDocumentPreviewModal({ documentId, onClose }: { documentId: string; onClose: () => void }) {
  const docQuery = useQuery({ queryKey: ['documentation', documentId], queryFn: async () => (await documentationApi.get(documentId)).data })
  const doc = docQuery.data

  const copy = async () => {
    if (!doc) return
    await navigator.clipboard.writeText(doc.content)
    toast.success('Inhalt kopiert')
  }

  return (
    <Modal
      title={doc?.title ?? 'Dokument'}
      onClose={onClose}
      size="lg"
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Schließen
          </Button>
          <Button variant="primary" disabled={!doc} onClick={copy}>
            Kopieren
          </Button>
        </>
      }
    >
      {doc ? <MarkdownRenderer content={doc.content} /> : <span style={{ color: 'var(--text-muted)' }}>Lädt…</span>}
    </Modal>
  )
}
